document.addEventListener('DOMContentLoaded', function() {
  var openSearchBtn = document.getElementById('open-search-manually');
  var searchModal = document.getElementById('custom-search-modal-unique');
  var closeSearchBtn = document.querySelector('.custom-modal__close-button');
  var overlay = document.querySelector('.custom-modal__overlay');

  openSearchBtn.addEventListener('click', function() {
    searchModal.classList.remove('hidden');
    document.getElementById('Search-In-Modal').focus();
  });

  closeSearchBtn.addEventListener('click', function() {
    searchModal.classList.add('hidden');
  });

  overlay.addEventListener('click', function() {
    searchModal.classList.add('hidden');
  });

  document.querySelectorAll('.ajax-cart-form').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        }
      })
        .then(res => res.json())
        .then(data => {
          alert(`✅ Added "${data.title}" to cart!`);
        })
        .catch(err => {
          alert('❌ Error adding to cart.');
          console.error(err);
        });
    });
  });
  
});
